import { Mapper } from '../core/types'
import { defaultMappers } from './defaultMappers'
import { mapAddressHistoryMotiv } from '../domain/address'
import { mapEmploymentHistoryEmployedWithTown } from '../domain/employment'
import { constant, chainMappers, defaultIfEmpty } from '../dsl/blocks'

export type PartnerStrategy = Partial<typeof defaultMappers>

// registry
export const partnerRulesMap: Record<string, PartnerStrategy> = {}


// MOTIV-like partners
// - defaults driving licence if empty
// - forces vehicle to car
const motivGroup = ['motiv', 'motivrefinance', 'close']
for (const s of motivGroup) {
    partnerRulesMap[s] = {
        vehicleType: constant<string>('car'),
        addressHistory: ((_, ctx) => mapAddressHistoryMotiv(ctx.answers)) as Mapper<any>,
        employmentHistory: ((_, ctx) =>
            mapEmploymentHistoryEmployedWithTown(ctx.answers, {
                forceYears: '2',
                forceMonths: '0'
            })) as Mapper<any>
    }
}

// FREEDOMFINANCE-T1
// - defaults driving licence if empty
// - sets jub title as UNKNOWN
partnerRulesMap['freedomfinance-t1'] = {
    ...(partnerRulesMap['freedomfinance-t1'] ?? {}),
    maritalStatus: constant<string>('single'),
    drivingLicence: chainMappers<string>(defaultIfEmpty('full uk driving licence', 'drivingLicence')),
    employmentHistory: ((_, ctx) =>
        mapEmploymentHistoryEmployedWithTown(ctx.answers, { jobTitleUnknown: true })) as Mapper<any>
}

// CLOSE
// - defaults driving licence if empty
partnerRulesMap['close'] = {
    ...(partnerRulesMap['close'] ?? {}),
    drivingLicence: chainMappers<string>(defaultIfEmpty('full uk driving licence', 'drivingLicence'))
}

// EXPERIAN
// - forces vehicle to car
// - defaults driving licence if empty
partnerRulesMap['experian'] = {
    ...(partnerRulesMap['experian'] ?? {}),
    maritalStatus: constant<string>('single'),
    vehicleType: constant<string>('car'),
    drivingLicence: chainMappers<string>(defaultIfEmpty('full uk driving licence', 'drivingLicence'))
}

// CLEARSCORE
// - defaults driving licence if empty
// - sets companyName to UNKNOWN when employed
partnerRulesMap['clearscore'] = {
    ...(partnerRulesMap['clearscore'] ?? {}),
    maritalStatus: constant<string>('single'),
    drivingLicence: chainMappers<string>(defaultIfEmpty('full uk driving licence', 'drivingLicence')),
    employmentHistory: ((_, ctx) =>
        mapEmploymentHistoryEmployedWithTown(ctx.answers, { companyNameUnknown: true })) as Mapper<any>
}

// CARMOOLA
// - defaults driving licence if empty
partnerRulesMap['carmoola'] = {
    ...(partnerRulesMap['carmoola'] ?? {}),
    drivingLicence: chainMappers<string>(defaultIfEmpty('full uk driving licence', 'drivingLicence'))
}
